










import Vue from 'vue'
import {mapState} from 'vuex'
import * as types from '../store/types'
import * as actions from '../store/actions'
import * as fields from '../store/fields'

const initializeVisibleButtonsFromButtonMap = (buttonsMap: any) => {
  return Object.keys(buttonsMap).reduce((accumulator: any, key: string) => {
    accumulator[key] = true
    return accumulator
  },{})
}

const mapLayersToButtons = (layers: Array<any>) => {
  return layers.reduce((accumulator: any, layer: any) => {
    //if the layer hasn't been added yet, create a new entry
    //in the dictionary
    if (!Object.prototype.hasOwnProperty.call(accumulator, layer.cc_type)) {
      /* eslint @typescript-eslint/camelcase: ["error", {properties: "never"}]  */ 
      accumulator[layer.cc_type] = {
        layer_id: layer.id,
        label: layer.label,
        layers: [layer]
      }
    } else {
      //if it does already exist, add to its layers
       accumulator[layer.cc_type].layers.push(layer) 
    }
    
    return accumulator
  }, {})
}

export default Vue.extend({
  name: 'CCMapLayerButtons',
  
  data() {
    return {
      visibleButtons: {} as any
    };
  },

  computed: mapState({
    layers: (state: any) => (state.map.layers as Array<any>),
    buttonsMap: (state: any) => mapLayersToButtons(state.map.layers || [])
  }),


  methods: {
    onButtonClick(buttonId: string){
      // toggle the button on/off and then
      // switch the visiblity of the mapbox layers controlled by this button
      this.visibleButtons[buttonId] = !this.visibleButtons[buttonId]
      this.buttonsMap[buttonId].layers.forEach((layer: any) => {
        this.$store.commit(actions.TOGGLE_LAYER, layer.id)  
      })
    }
  },

  created() {
    this.visibleButtons = initializeVisibleButtonsFromButtonMap(this.buttonsMap)
  },

  watch: {
    layers(newLayers, oldLayers) {
      
      if (oldLayers.length === 0) {
        console.log(oldLayers)
        this.visibleButtons = initializeVisibleButtonsFromButtonMap(this.buttonsMap)
      }
      //we have to also check here, in case the layers don't load until after the
      //component is created
      // this.visibleButtons = Object.assign({}, 
      //   this.visibleButtons,
      //   initializeVisibleButtonsFromButtonMap(this.buttonsMap))
    }
  }

}) as any;
